import { Component, Input } from '@angular/core';
import { NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ClaimDto } from 'src/app/auto-generated-server-dtos/adjuster/claim/claim-dto';
import { AdjusterDeleteClaimModalComponent } from './adjuster-delete-claim-modal/adjuster-delete-claim-modal.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-adjuster-delete-claim',
  standalone: true,
  imports: [CommonModule, NgbTooltip],
  templateUrl: './adjuster-delete-claim.component.html',
  styleUrl: './adjuster-delete-claim.component.scss'
})
export class AdjusterDeleteClaimComponent {
  @Input() claimDto!: ClaimDto;
  deleteDisabled: boolean = false;

  constructor(private ngbModal: NgbModal) {
  }
  ngOnInit() {
    this.deleteDisabled = this.disableDelete();
  }
  openDeleteClaimModal() {
    const modalRef = this.ngbModal.open(AdjusterDeleteClaimModalComponent, {
      size: "md"
    })
    modalRef.componentInstance.claimDto = this.claimDto;
  }

  disableDelete() {
    return this.claimDto.isLocked || this.claimDto.isClaimTestData;
  }
}
